<template>
    <div class="pagination">
        <a v-if="enablePrev" @click="moveIndex(-1)" class="pagination__prev" href="javascript:void(0)"
            aria-label="Previous results page"><span>PREV</span></a>
        <p v-else class="pagination__prev"><span>PREV</span></p>
        <div class="pagination__number-container">
            <template v-for="(item, index) in results.totalPages">
                <template v-if="checkPaginationVisibility(index)">
                    <p :key="index" v-if="index == currentPage" class="pagination__number pagination__number--active">{{index + 1}}</p>
                    <a :key="index" v-else @click="selectIndex(index)" class="pagination__number"
                        href="javascript:void(0)">{{index + 1}}</a>
                </template>
                <template v-else>
                    <span :key="index" class="pagination__ellipsis">...</span>
                </template>
            </template>
        </div>
        <a v-if="enableNext" @click="moveIndex(1)" class="pagination__next" href="javascript:void(0)"
            aria-label="Next results page"><span>NEXT</span></a>
        <p v-else class="pagination__next"><span>NEXT</span></p>
    </div>
</template>

<script>
    export default {
        created() {
            window.addEventListener('keydown', (e) => {
                if (e.keyCode == 37 && this.enablePrev) {
                    // left
                    this.moveIndex(-1);
                    this.submitPage;
                }

                if (e.keyCode == 39 && this.enableNext) {
                    //right
                    this.moveIndex(1);
                    this.submitPage;
                }
            })
        },
        methods: {
            checkPaginationVisibility(i) {
                let cp = this.currentPage;
                let tp = this.results.totalPages;

                if (tp <= 9) return true;
                if (i === 0) return true
                if (i === tp - 1) return true

                if (cp < 4) {
                    if (i < 4) return true;
                }

                if (Math.abs(cp - i) <= 2) return true

                if (cp > tp - 5) {
                    if (i > tp - 5) return true;
                }

                return false;
            },
            selectIndex: function (index) {
                this.pIndex = index;
                this.submitPage();
            },
            moveIndex: function (increment) {
                this.pIndex += increment;
                this.submitPage();
            },
            submitPage: function () {
                this.$emit('submitPage', this.pIndex);
            },
            resetIndex: function () {
                this.pIndex = 0;
            }

        },
        data: function () {
            return {
                pIndex: 0
            }
        },
        mounted() {
            this.pIndex = this.query.currentPage;
        },
        computed: {    
            currentPage() {
                return this.query.currentPage;
            },
            settings: function () {
                return this.$store.state.settings;
            },
            enablePrev: function () {
                return this.pIndex > 0;
            },
            enableNext: function () {
                return this.pIndex + 1 < this.results.totalPages;
            },
            results: function () {
                return this.$store.state.results;
            },
            query: function () {
                return this.$store.state.searchQuery;
            }
        }
    }
</script>